import React, { FC, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import LikeButton from "./LikeButton";
import Prices from "./Prices";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
import { Product, PRODUCTS } from "data/data";
import { StarIcon } from "@heroicons/react/24/solid";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import BagIcon from "./BagIcon";
import toast from "react-hot-toast";
import { Transition } from "@headlessui/react";
import ModalQuickView from "./ModalQuickView";
import ProductStatus from "./ProductStatus";
import { useDispatch } from "react-redux";
import WishlistService from "app/services/wishlistService";
import MessageService from "app/services/messageService";
import { redirect } from "react-router-dom";
import { BoostIcon, DeleteIcon, MessageIcon, PriceTagIcon } from "./icons";
import ModalReportItem from "./ModalReportItem";
import ModalTransferToken from "./ModalTransferToken";
import ModalBoost from "./ModalBoost";
import ModalDelete from "./ModalDelete";
import Avatar from "shared/Avatar/Avatar";
import ModalPrice from "./ModalPrice";
import Basketervice from "app/services/basketService";

export interface ProductCardProps {
    className?: string;
    data: Product;
    isLiked?: boolean;
    mode?: 'message' | 'user'
}

const ProductCard: FC<ProductCardProps> = ({
    className = "",
    data,
    isLiked,
    mode
}) => {
    const {
        id,
        name,
        price,
        description,
        sizes,
        variants,
        variantType,
        status_id,
        status,
        thumb,
        medias,
        likes_count,
        market,
        discount
    } = data;
    const [variantActive, setVariantActive] = React.useState(0);
    const [showModalQuickView, setShowModalQuickView] = React.useState(false);
    const [showModalBoost, setShowModalBoost] = React.useState(false);
    const [showModalDelete, setShowModalDelete] = React.useState(false);
    const [showModalPrice, setShowModalPrice] = React.useState(false);
    const [discountS, setDiscount] = useState<number>(NaN);
    
    const [statusE, setStatusE] = React.useState(status_id);
    const navigate = useNavigate();

    const sendMessage = () => {
        MessageService.newMessage({
            message: id,
            type: 'item',
            received: market?.username
          }).then(data => {
            window.location.replace("/messages/"+market?.username);
           
          })
    }

    const addToBasket = () => {
        const data = {
            quantity: 1,
   
            size_id: 5,
            color_id: 1,
            product_id: id,
        }
        Basketervice.add(data).then(data => console.log(data))
    }
    // useEffect(() => {
    //     if(data.discount)
    //         setDiscount(data.discount)
    // }, [data])



    const getBorderClass = (Bgclass = "") => {
        if (Bgclass.includes("red")) {
        return "border-red-500";
        }
        if (Bgclass.includes("violet")) {
        return "border-violet-500";
        }
        if (Bgclass.includes("orange")) {
        return "border-orange-500";
        }
        if (Bgclass.includes("green")) {
        return "border-green-500";
        }
        if (Bgclass.includes("blue")) {
        return "border-blue-500";
        }
        if (Bgclass.includes("sky")) {
        return "border-sky-500";
        }
        if (Bgclass.includes("yellow")) {
        return "border-yellow-500";
        }
        return "border-transparent";
    };

    const renderVariants = () => {
        if (!variants || !variants.length || !variantType) {
        return null;
        }

        if (variantType === "color") {
        return (
            <div className="flex space-x-1">
            {variants.map((variant, index) => (
                <div
                key={index}
                onClick={() => setVariantActive(index)}
                className={`relative w-6 h-6 rounded-full overflow-hidden z-10 border cursor-pointer ${
                    variantActive === index
                    ? getBorderClass(variant.color)
                    : "border-transparent"
                }`}
                title={variant.name}
                >
                <div
                    className={`absolute inset-0.5 rounded-full z-0 ${variant.color}`}
                ></div>
                </div>
            ))}
            </div>
        );
        }

        return (
        <div className="flex ">
            {variants.map((variant, index) => (
            <div
                key={index}
                onClick={() => setVariantActive(index)}
                className={`relative w-11 h-6 rounded-full overflow-hidden z-10 border cursor-pointer ${
                variantActive === index
                    ? "border-black dark:border-slate-300"
                    : "border-transparent"
                }`}
                title={variant.name}
            >
                <div className="absolute inset-0.5 rounded-full overflow-hidden z-0">
                <img
                    src={`${process.env.REACT_APP_API_URL}${variant.thumbnail}`}
                    alt="variant"
                    className="absolute w-full h-full object-cover"
                />
                </div>
            </div>
            ))}
        </div>
        );
    };

    const renderGroupButtons = () => {
        return (
        <div className="absolute bottom-0 group-hover:bottom-4 inset-x-1 flex justify-center opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
            {/* {!mode ? 
                <ButtonPrimary
                className="shadow-lg"
                fontSize="text-xs"
                sizeClass="py-2 px-4"
                onClick={() => sendMessage()}
                >
               <MessageIcon className="w-5 h-5"/>
                <span className="ml-1">Contacter</span>
                </ButtonPrimary>
                : null
            } */}

             {!mode ? 
                <ButtonPrimary
                className="shadow-lg"
                fontSize="text-xs"
                sizeClass="py-2 px-4"
                onClick={() => addToBasket()}
                >
               <BagIcon className="w-5 h-5"/>
                <span className="ml-1">add</span>
                </ButtonPrimary>
                : null
            }

            {mode === 'user'  &&  [3,5].includes(status_id)  ?
                <ButtonPrimary
                className="shadow-lg"
                fontSize="text-xs"
                sizeClass="py-2 px-4"
                onClick={() => setShowModalBoost(true)}
                >
               <BoostIcon className="w-5 h-5"/>
                <span className="ml-1">Bosster</span>
                </ButtonPrimary>
                : null
            }
            
            <ButtonSecondary
            className="ml-1.5 bg-white hover:!bg-gray-100 hover:text-slate-900 transition-colors shadow-lg"
            fontSize="text-xs"
            sizeClass="py-2 px-4"
            onClick={() => setShowModalQuickView(true)}
            >
            <ArrowsPointingOutIcon className="w-3.5 h-3.5" />
            <span className="ml-1">Aperçu rapide</span>
            </ButtonSecondary>
        </div>
        );
    };

 
 
    return (
        <>
        <div
            className={`nc-ProductCard relative flex flex-col bg-transparent ${className}`}
            data-nc-id="ProductCard"
            id={`product-${id}`}
        >
            <Link to={`/shop/${name ? name.replaceAll(' ', '-') : ''}/${id}`} className="absolute inset-0"></Link>

            <div className="relative flex-shrink-0 bg-slate-50 dark:bg-slate-300 rounded-xl overflow-hidden z-1 group">
            <Link to={`/shop/${name ? name.replaceAll(' ', '-'): ''}/${id}`} className="block">
                <NcImage
                containerClassName="flex aspect-w-11 aspect-h-12 w-full h-0"
                src={process.env.REACT_APP_API_URL+thumb}
                className="object-cover w-full h-full drop-shadow-xl"
                />
            </Link>

            <ProductStatus status={status} />

            <LikeButton  id={data.id} className="absolute top-3 right-3 z-10" />
            {
            mode === 'user' ?
                <>
                  <button onClick={() => setShowModalDelete(true)} className="absolute top-14 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-white">
                <DeleteIcon className=""/>
                </button>

                <button onClick={() => setShowModalPrice(true)} className="absolute top-[100px] right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-white">
                <PriceTagIcon className=""/>
                </button>
                </>
              
            : null
            }
            {renderGroupButtons()}
           {/* {sizes ? renderSizeList() : renderGroupButtons()} */}
            </div>

            <div className="space-y-4  pt-5 pb-2.5">
            {renderVariants()}

            <div className="flex items-center">
            <Link to={`/shop/${market?.username}`} className="block">
             <Avatar containerClassName="mr-2" imgUrl={`${ process.env.REACT_APP_API_URL}/api/media/avatar/${market?.username}`} sizeClass="w-10 h-10" />

            </Link>
               
                
                <h2
                className={`nc-ProductCard__title text-base font-semibold transition-colors`}
                >
                    	
                  
                {name}
                </h2>
                <p className={`text-sm text-slate-500 dark:text-slate-400 mt-1 `}>
          
                </p>
            </div>

            <div className="flex justify-between items-end ">
                
                
                { discount || discountS ? 
                <div className="flex">
                 <Prices price={price} className="line-through " contentClass="text-xs py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium border-none text-red-600"/> 
                 <Prices price={discount || discountS} />
                </div>
                : <Prices price={price} />}
                <div className="flex items-center mb-0.5">
                {/* <StarIcon className="w-5 h-5 pb-[1px] text-amber-400" /> */}
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
                    <path
                    d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z"
                    stroke={"currentColor"}
                 
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    />
                </svg>
                <span className="text-sm ml-1 text-slate-500 dark:text-slate-400">
                    {/* {(Math.random() * 1 + 4).toFixed(1)} (
                    {Math.floor(Math.random() * 70 + 20)} reviews) */}
                    {likes_count}
                </span>
                </div>
            </div>
            </div>
        </div>

        {/* QUICKVIEW */}
        <ModalQuickView
            show={showModalQuickView}
            product={data}

            onCloseModalQuickView={() => setShowModalQuickView(false)}
        />

           {
            showModalBoost ?
            <ModalBoost 
                show={showModalBoost}
                productId={id}
                onCloseModalBoost={() => setShowModalBoost(false)}
                onBoostClick={() => setStatusE(4)}
            /> : null
           }    

           {
            showModalDelete ?
            <ModalDelete
            show={showModalDelete}
            productId={id}
            onCloseModalDelete={() => setShowModalDelete(false)}
            onDeleteClick={() => {
                const p = document.getElementById(`product-${id}`)
                p?.remove()
            }} 
           /> : null
         
           }


            {
            showModalPrice ?
            <ModalPrice
            show={showModalPrice}
            productId={id}
            onCloseModalPrice={() => setShowModalPrice(false)}
            onChangeClick={(p) => {
              setDiscount(p)
            }}
           />  : null
         
           }
          
                   
        

        
        </>
        );
};

export default ProductCard;
